import * as React from "react";
import { liteClient } from "algoliasearch/lite";
import { AlgoliaConfigProvider } from "./AlgoliaConfigProvider.js";
import { AlgoliaServerState } from "./AlgoliaServerState.js";
import { getAlgoliaServerState } from "./get-algolia-server-state.js";
import { addFacetVisibility } from "../utils/Algolia/utils/add-facet-visibility.js";
import { parseCommercialFacets } from "../utils/Algolia/utils/parse-commercial-facets.js";
async function getCommercialCategories(searchClient, indexName, locale, isMultilingualEnabled) {
  try {
    const prefetchFacetsResult = await searchClient.search({
      requests: [{ indexName, query: "", facets: ["*"] }]
    });
    const rawFacets = prefetchFacetsResult.results[0]?.facets ?? {};
    const commercialFacets = parseCommercialFacets({ rawFacets, locale, isMultilingualEnabled });
    return commercialFacets;
  } catch (error) {
    console.error("An error occurred while fetching algolia commercial categories:", error);
  }
  return [];
}
const enrichAlgoliaConfig = async (props, router) => {
  const {
    isEnabled,
    locale,
    presetQueryString,
    isMultilingualEnabled,
    options: { apiKey, appId, indexName }
  } = props;
  if (!isEnabled) {
    return props;
  }
  const searchClient = liteClient(appId, apiKey);
  const commercialFacets = await getCommercialCategories(
    searchClient,
    indexName,
    locale,
    isMultilingualEnabled
  );
  const enrichedProps = {
    ...props,
    searchClient,
    options: {
      ...props.options,
      facets: addFacetVisibility(
        [...props.options.facets, ...commercialFacets],
        locale,
        presetQueryString
      )
    }
  };
  const serverState = await getAlgoliaServerState(
    /* @__PURE__ */ React.createElement(AlgoliaConfigProvider, { ...enrichedProps, router }, /* @__PURE__ */ React.createElement(AlgoliaServerState, null))
  );
  return {
    ...enrichedProps,
    serverState
  };
};
export {
  enrichAlgoliaConfig,
  getCommercialCategories
};
//# sourceMappingURL=enrich-algolia-config.js.map
